import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ActionReasonEnum} from "../../enums/action-reason.enum";

export class ActionReasonMultiSelectListComponent implements IController {
  actionReasons: ActionReasonEnum[];
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;

  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = Object.values(ActionReasonEnum);
    }
  }

  $onChanges(changes) {
    if (changes.actionReasons) {
      this.selectedKeys = [];
      _.forEach(this.actionReasons, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  onToggle(option, isSelected) {
    this.onChange({
      actionReasons: isSelected ? _.concat(this.actionReasons || [], [option]) :
        _.filter(this.actionReasons, (type) => {
          return type !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({actionReasons: []});
  }

}

angular
  .module('bringoz.admin.action-reasons')
  .component('actionReasonMultiSelectList', {
    bindings: {
      actionReasons: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./action-reason-multi-select-list.html').default,
    controller: ActionReasonMultiSelectListComponent
  });

